import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";

export default function EventReport() {
  useEffect(() => {}, []);

  return (
    <Grid container className="homepage-container">
      <Grid item xs={12} sm={12} md={12} className="mt-1 d-flex jc-center">
        <iframe
          title="Event Report"
          className="i-frame"
          width="1300"
          height="520"
          src="https://app.powerbi.com/reportEmbed?reportId=a77e0374-0209-49c5-a9bc-aace400e30da&autoAuth=true&ctid=38ae3bcd-9579-4fd4-adda-b42e1495d55a"
          frameborder="0"
          allowFullScreen="true"
        />
      </Grid>
    </Grid>
  );
}
